import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import fieldTranslations from 'modules/payroll_integrations_datev_api/lib/fieldTranslations'
import type { Sync } from 'modules/payroll_integrations_datev_lauds/lib/IncidenceSync/store'

const Unavailable = ({
  onSync,
  syncing,
  sync,
}: {
  onSync: () => void
  syncing: boolean
  sync: Sync
}) => {
  return (
    <>
      <Box gap="s4" flexDirection="row">
        <Icon.Medium icon="alert-circle-line" color="radicalRed1000" />
        <Text.Header2>
          {i18n.t('payroll_integrations.incidences.datev_lauds.termination.unavailable.title')}
        </Text.Header2>
      </Box>
      <Box gap="s4">
        {i18n.t('payroll_integrations.incidences.datev_lauds.termination.unavailable.message')}
      </Box>
      {sync.unavailable_fields && sync.unavailable_fields.length > 0 && (
        <Box component="ul" paddingX="s8">
          {sync.unavailable_fields.map((field) => (
            <Box component="li" key={field}>
              {fieldTranslations.t(field)}
            </Box>
          ))}
        </Box>
      )}
      <Button onClick={onSync} disabled={syncing}>
        {i18n.t('payroll_integrations.incidences.datev_lauds.termination.unavailable.submit')}
      </Button>
    </>
  )
}

export default Unavailable
